import { Breakpoint } from '@altibox/design-system-component-lib';
import React, { FC } from 'react';

import { Link, LinkTheme } from 'src/components/link';

import { StyledLinkContainer } from './footer-external-link.styled';

interface Props {
  label: string;
  url: string;
}

export const FooterExternalLink: FC<Props> = (props) => {
  const { label, url } = props;

  return (
    <StyledLinkContainer>
      <Link variant="paragraph2" href={url} maxBreakpoint={Breakpoint.TABLET} $focusTheme={LinkTheme.DARK}>
        {label}
      </Link>
    </StyledLinkContainer>
  );
};
